import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const dagster = defineConnector({
  identifier: "dagster",
  name: "Dagster",
  tagLine: "Data orchestration platform",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://[^/]*\\.dagster\\.cloud/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Dagster-Cloud-Api-Token",
        value: app.secret.apiToken,
      },
    ]),
  steps: [
    {
      title: "Get your Dagster Cloud token",
      items: [
        {
          kind: "markdown",
          content:
            "In [Dagster Cloud](https://dagster.cloud), go to your **organization settings** and create a new **user token**.",
        },
        {
          kind: "input",
          label: "Organization name",
          required: true,
          placeholder: "my-org",
          target: { kind: "configuration", field: "orgName" },
        },
        {
          kind: "input",
          label: "Deployment name",
          required: true,
          placeholder: "prod",
          target: { kind: "configuration", field: "deploymentName" },
          helperText: "The name of the deployment (e.g., prod, staging).",
        },
        {
          kind: "input",
          label: "User token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ orgName, deploymentName }) => ({
      url: `https://${orgName}.dagster.cloud/${deploymentName}/graphql`,
      expectedStatus: 200,
    }),
  },
});
